import { useNavigate } from "react-router-dom";

import util from "utils/utils";

import BaseChip, { type ChipConfiguration } from "./BaseChip";

const ProfileChip = ({
  profile,
  forType = "profile",
  ...props
}: ChipConfiguration & {
  forType?: "profile" | "organisation";
  profile: { _id: string; name: string; overview?: string };
}) => {
  const navigate = useNavigate();

  return (
    <BaseChip
      {...props}
      style={{ maxWidth: 200 }}
      onClick={
        props.disabled ? undefined : (
          (e) => {
            if (props.onClick) {
              props.onClick(e);
            } else {
              if (forType === "profile") {
                navigate(`/profiles/${profile?._id}`);
              }
            }
          }
        )
      }
      title={profile?.name}
      subtitle={profile?.overview}
      imageUrl={util.profileLogo(profile)}
      avatarBackgroundSize={forType === "organisation" ? "contain" : "cover"}
    />
  );
};

export default ProfileChip;
